import HyriaIcon from './HyriaIcon';
import ApplicationIcon from './ApplicationIcon';
import FacebookIcon from './FacebookIcon';
import InstagramIcon from './InstagramIcon';
import LinkedinIcon from './LinkedinIcon';
import HamburgerIcon from './HamburgerIcon';
import LockIcon from './LockIcon';

export const ICON_NAMES = {
  hyria: HyriaIcon,
  application: ApplicationIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  hamburger: HamburgerIcon,
  lock: LockIcon
};
